import { Route } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { RegistrationComponent } from './lib/containers/registration/registration.component';
import { RegisterInitComponent } from './lib/containers/register-init/register-init.component';
import { RegisterProfileComponent } from './lib/containers/register-profile/register-profile.component';

export * from './lib/containers/registration/registration.component';
export * from './lib/containers/register-init/register-init.component';
export * from './lib/containers/register-profile/register-profile.component';
export * from './lib/components/account-form/account-form.component';
export * from './lib/components/profile-form/profile-form.component';

export const registerAccountRoutes: Route[] = [
  {
    path: 'register',
    component: RegistrationComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'account' },
      {
        path: 'account',
        component: RegisterInitComponent,
        pathMatch: 'full',
      },
      // Create-profile step (#1760): creates the app's Customer row for the
      // AUTHENTICATED Auth0 identity via POST customer-self-service-api/profile.
      // AuthGuard is required — the backend derives the identity email from the
      // JWT, so an unauthenticated visitor is sent through Auth0 login first
      // (and bounced right back here afterwards).
      {
        path: 'profile',
        component: RegisterProfileComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];
